import { SectionType } from '@/libs/types'
import clsx from 'clsx'
import React from 'react'
import SectionContent from './SectionContent'
import SectionThumb, { ThumbOneOverrideProps } from './SectionThumb'
import SectionVideo from './SectionVideo'

interface SectionProps {
    section: SectionType
    locale: string
}

const Section: React.FC<SectionProps> = ({
    section,
    locale
}) => {

    const { cols, classes, heading, subheading, quote, description, content, video, thumbs } = section

    return (
        <div className={clsx(`col-${cols || 12}`, "section", classes)}>
            {/* section heading */}
            {!!heading &&
                <h2 className="mt-5 mb-4">
                    {heading}
                </h2>}
            {/* section subheading */}
            {!!subheading &&
                <h4 className="fw-bold">
                    {subheading}
                </h4>}
            {/* section quote - same with post*/}
            {!!quote && <blockquote className="my-5">
                <span className="h4">
                    {quote}
                </span>
            </blockquote>}
            {/* section description - same with post*/}
            {!!description && <p className="fw-bold">
                {description}
            </p>}
            {!!video && <SectionVideo video={video} />}
            {(thumbs && thumbs.length !== 0) && <div className="row justify-content-center">
                {thumbs?.filter((thumb: ThumbOneOverrideProps) => !thumb.position || thumb.position !== "bottom")?.map((thumb: ThumbOneOverrideProps, index: number) => {
                    return (
                        <SectionThumb
                            thumb={{ ...thumb }}
                            section={{
                                heading: heading
                            }}
                            key={index}
                        />)
                })}
            </div>}
            {!!content && <SectionContent content={content} locale={locale} classes="mb-5 text-justify" />}
            <div className="row justify-content-center">
                {(thumbs && thumbs.length !== 0) && thumbs?.filter((thumb: ThumbOneOverrideProps) => !!thumb.position && thumb.position === "bottom")?.map((thumb: ThumbOneOverrideProps, index: number) => {
                    return (
                        <SectionThumb
                            thumb={{ ...thumb }}
                            section={{
                                heading: heading
                            }}
                            key={index}
                        />)
                })}
            </div>
        </div>
    )
}

export default Section